import { styled } from '@mui/material';

export const BenefitPreviewTileStyled = styled('div')({
  borderRadius: 8,
});

export const CarrierLogoStyled = styled('div')({
  margin: 'auto',
});

export const CarrierImageStyled = styled('img')({
  maxHeight: '48px',
  maxWidth: '141px',
  display: 'block',
  margin: 'auto',
});

export const SelectedBottomStyled = styled('div')({
  ':only-child': {
    margin: 'auto',
  },
});

export const InfoContentStyled = styled('div')({
  border: 'solid 1px var(--wcag-orange)',
  borderRadius: '4px',
  padding: '4px 6px',
  justifyContent: 'center',
  textAlign: 'center',
  backgroundColor: '#FFFBF6',
  width: 'fit-content',
});

export const BenefitTextStyled = styled('p')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: '5',
  WebkitBoxOrient: 'vertical',
});

export const ShortBenefitTextStyled = styled('p')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: '2',
  WebkitBoxOrient: 'vertical',
});
